import { useRouter } from 'next/router';
import { useEffect, useState, useMemo } from 'react';
import { GARAGE_ID_MAP, GARAGE_MAPPING, GARAGE_NAMES } from '../constants';
import { getGarageDetailsById } from '../api';
import { useDispatch, useSelector } from 'react-redux';
import { setGarageData } from '@/store/modules/garageSlice';
import { useLoading } from '@/hooks/useLoading';

const useGarageDetails = (initialGarageId?: string) => {
    const router = useRouter();
    const dispatch = useDispatch();
    const [garageId, setGarageId] = useState<string>('');
    const selectedGarageData = useSelector((state: any) => {
        return state.currentGarageData?.selectedGarageData;
    });
    const { start, stop, isLoading } = useLoading('loading-garage-data');

    const fetchGarageData = async (id: string) => {
        // Only fetch if we don't have the data in Redux for garage
        if (isLoading || !id) return;
        if (!selectedGarageData) {
            start();
            console.log('selectedGarageData', isLoading, selectedGarageData);

            const res = await getGarageDetailsById(id);
            dispatch(setGarageData(res));
            stop();
        }
    };

    useEffect(() => {
        if (!router.isReady) return;
        const getGarageId = () => {
            if (initialGarageId) return initialGarageId;
            if (typeof window === 'undefined') return '';

            const queryGarageId = router.query.garageId as string;
            const sessionGarageId = window.sessionStorage.getItem('garageId');

            return queryGarageId || sessionGarageId || '';
        };

        const id = getGarageId();
        setGarageId(id);
        fetchGarageData(id);
        if (typeof window !== 'undefined' && id) {
            window.sessionStorage.setItem('garageId', id);
        }
    }, [router.isReady, router.query.garageId, initialGarageId]);

    const garageDetails = useMemo(() => {
        if (!garageId || !(garageId in GARAGE_MAPPING)) {
            return { garageName: '', garagePageUrl: '' };
        }
        const details = GARAGE_MAPPING[garageId];
        return {
            garageName: details.displayName,
            garagePageUrl: details.routePath,
        };
    }, [garageId]);

    console.log('garage', garageId, garageDetails);

    return {
        garageId,
        garageName: garageDetails.garageName,
        garagePageUrl: garageDetails.garagePageUrl,
        currentGarageData: selectedGarageData,
    };
};

export default useGarageDetails;
